import React from 'react';
import { motion } from "framer-motion";
import './Header.scss';
import  { AppWrap} from '../../wrapper'
import { images } from '../../constants';




const scaleVariants = {
  whileInView: {
    scale: [0,1],
    opacity:[0,1],
    transition: {
      duration: 1,
      ease: 'easeInOut'
    }
  }
    
  
}

//IDEA: make an on hover effect for the images using framer motion

const Header = () => {
  return (


  
    <div className='app__header app__flex'>
    <motion.div
    whileInView={{ x:[-100,0], opacity: [0,1] }}
    transition={{ duration: 0.5 }}
    className="app__header-info"
    >

    <div className='app__header-badge'>
        <div className='badge-cmp app_flex'>
            <span></span>
            <div>
              <p className='p-text'></p>
              <h1 className='head-text'>Jacob Metcalfe</h1>
              <p>Web Developer</p>
              <p>Computer Science Graduate</p>
            </div>
        </div>
      

      {/* <div className='tag-cmp app__flex'>
        <p className='p-text'>Web Developer</p>
        <p className='p-text'>Computer Science Graduate</p>
      </div> */}
    </div>
    </motion.div>

    <motion.div
    variant={scaleVariants}
    whileInView={scaleVariants.whileInView}
    className="app__header-circles circle-hover mobile"
    >
    {[images.react, images.node, images.bootstrap].map((circle,index) => (
      <div className='circle-cmp app__flex' key={`circle-${index}`}>
      <img src={circle} alt="circle" />
      </div>

    ))}
 
    </motion.div>


    
    <motion.div
    whileInView={{ opacity: [0,1] }}
    transition={{ duration: 0.5, delayChildren: 0.5 }}
    className="app__header-img"
    >
      <img src={images.portrait} alt="profile_bg"/>
      
      <motion.img
        whileInView={{ scale: [0, 1] }}
        transition={{ duration: 1, ease: 'easeInOut' }}
        src={images.circle}
        alt="profile_circle"
        className="overlay_circle"
      />  

    </motion.div>


    <motion.div
    variant={scaleVariants}
    whileInView={scaleVariants.whileInView}
    className="app__header-circles circle-hover default"
    >
    {[images.react, images.node, images.bootstrap].map((circle,index) => (
      <div className='circle-cmp app__flex' key={`circle-${index}`}>
      <img src={circle} alt="circle" />
      </div>

    ))}
 
    </motion.div>

    </div>
  )
}

export default AppWrap(Header, 'home')
//export default Header